import React from 'react'
import './index.css'
import View from 'components/View'

/**
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductAOVUnlockIcon () {
  return (
    <View className='product-aov-unlock-icon'>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          width='31.9999'
          height='31.9999'
          rx='5.99998'
          fill='#FDD5F3'
        />
        <path
          d='M15.5 13L9.5 21.5L11 24.5H15.5L22.5 14.5L20 13.5L15.5 13Z'
          fill='#FFA6EB'
        />
        <path
          d='M16 19.3334V21M12.25 24.3334H19.7504C21.1311 24.3334 22.2504 23.2141 22.2504 21.8334V15.7223C22.2504 14.3416 21.1311 13.2223 19.7504 13.2223H12.25C10.8693 13.2223 9.75 14.3416 9.75 15.7223V21.8334C9.75 23.2141 10.8693 24.3334 12.25 24.3334ZM17.25 17.6667C17.25 18.3571 16.6904 18.9167 16 18.9167C15.3096 18.9167 14.75 18.3571 14.75 17.6667C14.75 16.9764 15.3096 16.4167 16 16.4167C16.6904 16.4167 17.25 16.9764 17.25 17.6667Z'
          stroke='#191531'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.9065 13.0821L13.3641 10.7129C12.9789 9.0305 14.0306 7.35438 15.713 6.96921C17.3954 6.58404 19.0715 7.63567 19.4567 9.31809'
          stroke='#191531'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </View>
  )
}
